module.exports = __webpack_public_path__ + "static/media/risk-assesment_placeholder.0ef1005f.png";